import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/product-category/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const productCategory = {
  get: apiPathFunc(pathBase),
} as const;
